if (!customElements.get("accordion-wrapper")) {
  class Accordion extends HTMLElement {
    constructor() {
      super();
      this.options = this.dataset.options;
      this.onlyOneActive = false;
    }

    connectedCallback() {
      this.items = this.querySelectorAll(".td-accordion__item");
      if (this.items.length) {
        this.bindEvents();
      }
    }

    bindEvents() {
      const el = this;
      this.items.forEach(function (item) {
        const toggle = item.querySelector(".td-accordion__toggle");
        if (toggle) {
          toggle.addEventListener("click", function (event) {
            event.preventDefault();
            el.toggle(item.dataset.item);
          });
          if (item.dataset.open) {
            el.toggle(item.dataset.item);
          }
        }

        const toggleNext = item.querySelector(".td-accordion__toggle-next");
        if (toggleNext) {
          toggleNext.addEventListener("click", function (event) {
            event.preventDefault(), el.toggle(parseInt(item.dataset.item) + 1);
          });
        }
      });
    }

    toggle(currentItem) {
      const el = this;
      this.items.forEach(function (item) {
        const content = item.querySelector(".td-accordion__content");
        if (!content) return;
        if (item.dataset.item == currentItem) {
          if (item.classList.contains("is-active")) {
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
          }
          item.classList.toggle("is-active");
        } else if (el.onlyOneActive) {
          item.classList.remove("is-active");
          content.style.maxHeight = null;
        }
      });
    }
  }

  customElements.define("accordion-wrapper", Accordion);
}
